module.exports = __webpack_public_path__ + "img/support_primary.285469b1.svg";